/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomAddActionCard from '../../../../common/components/CustomAddActionCard/CustomAddActionCard';
import { Box, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import ClaimListTile from '../../../../common/components/ClaimListTile/ClaimListTile';
import { fonts, themes } from '../../../../common/themes/themes';
import ApplyClaimModalController from '../../../../common/Modals/Claims/ApplyClaimModal/ApplyClaimModalController';
import ClaimViewModalController from '../../../../common/Modals/Claims/ClaimViewModal/ClaimViewModalController';
import CustomAddButton from '../../../../common/components/CustomAddButton/CustomAddButton';
import {
  check_user_permission,
  getAmount,
} from '../../../../common/configs/utils';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import { useAppSelector } from '../../../../infra/hooks';

interface propsType {
  empClaims: any;
  isLoading?: boolean;
  trans?: any;
}

const ActiveLoansPresenter: React.FC<propsType> = ({
  empClaims,
  isLoading,
  trans,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [claimViewModalData, setClaimViewModalData] = useState({});
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );

  return (
    <>
      <CustomAddActionCard
        card_title={trans('Claims')}
        card_height="343px"
        onClick={() => setOpenModal(true)}
        card_subtitle={`${trans('Total')} : ${empClaims?.length}`}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {empClaims?.length > 0 ? (
              _.map(empClaims, (claim: any, i) => {
                return (
                  <div key={i}>
                    <Box style={{ marginBottom: '24px' }} />
                    <ClaimListTile
                      claimName={claim?.claim_type?.name}
                      amount={claim?.amount ? getAmount(claim?.amount) : '--'}
                      status={claim?.status}
                      travelDate={claim?.date}
                      onClickView={() => {
                        setClaimViewModalData(claim);
                        setOpenViewModal(true);
                      }}
                    />
                  </div>
                );
              })
            ) : (
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Applied')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any Claim Applications')}
                  </Typography>
                </Grid>
                {check_user_permission(auth_permissions, true, 'add') ? (
                  <Grid
                    item
                    xs={12}
                    style={{
                      textAlign: 'center',
                      marginTop: '1em',
                    }}
                  >
                    <CustomAddButton
                      btnLabel={trans('Apply Claim')}
                      onClick={() => setOpenModal(true)}
                    />
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
            )}
          </div>
        )}
      </CustomAddActionCard>

      {/* Claim List Apply Modal */}

      {openModal && (
        <ApplyClaimModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
        />
      )}

      {/* Claim List View Modal */}

      {openViewModal && (
        <ClaimViewModalController
          isModalOpen={openViewModal}
          closeModal={() => setOpenViewModal(false)}
          claimViewData={claimViewModalData}
        />
      )}
    </>
  );
};

export default ActiveLoansPresenter;
